import React from 'react'
import styles from './Problem.module.scss'

type Props = {
  contents: {
    title: string
    subTitle: string
    list: {
      icon: string
      text: string
    }[]
  }
}

export const Problem: React.FC<Props> = ({ contents }) => {
  return (
    <div className={styles.problem_container}>
      <div className={styles.main_container}>
        <div className={styles.problem_title_container}>
          <p className={styles.problem_title}>{contents.title}</p>
          <p className={styles.problem_subTitle}>{contents.subTitle}</p>
        </div>
        <div className={styles.problem_list_container}>
          {contents.list.map((item, index) => (
            <div key={index} className={styles.problem_list_item}>
              <div className={styles.problem_icon_container}>
                <img src={item.icon} alt="" className={styles.problem_icon} />
              </div>
              <p className={styles.problem_text}>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
